import { render, staticRenderFns } from "./ConfigurarLandingModalEdicion.vue?vue&type=template&id=30e06cf6&scoped=true&"
import script from "./ConfigurarLandingModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarLandingModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarLandingModalEdicion.vue?vue&type=style&index=0&id=30e06cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e06cf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('30e06cf6', component.options)
    } else {
      api.reload('30e06cf6', component.options)
    }
    module.hot.accept("./ConfigurarLandingModalEdicion.vue?vue&type=template&id=30e06cf6&scoped=true&", function () {
      api.rerender('30e06cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfigurarLanding/ConfigurarLandingModalEdicion.vue"
export default component.exports